// グローバルな定数などがあれば、ここに記載する
export const regexp = /^[0-9a-zA-Z\\.-_]{1,150}$/
export const numberRegexp = /^([1-9]\d*|0)$/
export const treeIdRegexp = /^[a-zA-Z0-9\-\\_]{1,128}$/
export const nameRegexp = /^([\\u0000-\uffff&&[^\\x00-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]]){1,128}$/
export const modelRegexp = /[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/+=¥r¥n]{1,16777216}$/
export const domainRegexp = /^[A-Za-z0-9][A-Za-z0-9-_.]+$/
export const pageNgRegexp = /^https?:\/\/.*$/
export const actionFormat = { actionId: '', versionId: '', mtime: '', utime: '', model: '', modelExtention: '', metadata: { name: '', type: '' }, configuration: { } }
export const actionRecommendAiConfigurationFormat = { type: 'recommend-ai', scenarioId: '' }
export const actionIconConfigurationFormat = { type: 'icon', downloadUrl: '', positionConfiguration: { widthUnits: '', heightUnits: '', widthType: '', heightType: '', width: '', height: '' }, textColor: '#666666', textLinkColor: '#00a0e9', textBackground: '#f6f6f6', userTextColor: '#ffffff', userTextBackground: '#10cfb2', buttonColor: '#00a0e9', buttonTextColor: '#ffffff', buttonAreaColor: '#f0f6fb' }
export const actionPopupConfigurationFormat = { type: 'popup', url: '', downloadUrl: '', positionConfiguration: { widthUnits: '', heightUnits: '', widthType: '', heightType: '', width: '', height: '' }, size: { height: '', heightUnits: '', width: '', widthUnits: '' } }
export const domainFormat = { fqdn: '', versionId: '', mtime: '', utime: '', metadata: { status: '' } }
export const frameFormat = { fqdn: '', frameId: '', versionId: '', mtime: '', utime: '', metadata: { name: '' }, configuration: { pages: [ { pattern: '', mode: 'eq_display' } ], actions: [ ], segments: [ ], rules: [ ] } }
export const decisiontreeFormat = { datasourceId: '', treeId: '', versionId: '', metadata: { name: '' }, model: '' }
export const actiontypes = ['popup', 'recommend-ai', 'icon']
export const POPUP = 'popup'
export const RECOMMENDAI = 'recommend-ai'
export const ICON = 'icon'
export const UPLOAD_ICON_LIMITATION = { LIMIT: 1000000, TEXT: '1MB' }
export const UPLOAD_POPUP_LIMITATION = { LIMIT: 5000000, TEXT: '5MB' }
export const operatorList = ['lt', 'le', 'eq', 'ge', 'gt', 'ne']
export const strOperatorList = ['eq', 'ne']
export const periodTypeList = ['hour', 'day', 'week', 'month']
export const dayOfWeekList = ['1', '2', '3', '4', '5', '6', '7']
export const scopeList = ['all', 'previous', 'current']
export const dayList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']
export const hourList = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
export const minuteList = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']
export const weekList = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
export const pageMode = { 'EQ_DISPLAY': '一致したら表示する', 'EQ_UNDISPLAY': '一致したら表示しない' }
export const categoryList = { 'session': 'セッション', 'schedule': 'スケジュール', 'stop': '停止', 'eventhistory': '実行履歴' }
export const categoryRuleList = {
  // 訪問回数(visit-count)は非表示にする
  'session': { 'last-page-view': '最後のページビュー日時', 'page-view-count': 'ページビュー数', 'stay-seconds': '滞在秒数', 'view-page-path': '閲覧ページのパス', 'last-page-path': '最後の閲覧ページのパス', 'walk-3pages': '3階層ページ遷移閲覧シナリオ', 'referer': 'リンク元ページ（リファラ）のホスト', 'utm-source': '閲覧ページのクエリキー（utm_source）', 'src-link-path': 'サイト内のリンク元ページのパス', 'user-os': 'アクセス時のOS名', 'stop-view-count': '配信回数上限で配信を停止' },
  'schedule': { 'day-period': '期間', 'day-of-week': '曜日', 'day-time': '時間' },
  'stop': { 'stop-view-count': '配信回数上限で配信を停止', 'stop-close-count': '閉じられた回数で配信を停止', 'stop-click-count': 'クリック回数で配信を停止' },
  'eventhistory': { 'frequency': '期間頻度', 'user-view-limit': 'ユーザー毎の発生回数' }
}
export const ruleList = {
  'visit-count': '訪問回数',
  'last-page-view': '最後のページビュー日時',
  'page-view-count': 'ページビュー数',
  'stay-seconds': '滞在秒数',
  'view-page-path': '閲覧ページのパス',
  'last-page-path': '最後の閲覧ページのパス',
  'walk-3pages': '3階層ページ遷移閲覧シナリオ',
  'referer': 'リンク元ページ（リファラ）のホスト',
  'utm-source': '閲覧ページのクエリキー（utm_source）',
  'src-link-path': 'サイト内のリンク元ページのパス',
  'user-os': 'アクセス時のOS名',
  'stop-view-count': '配信回数上限で配信を停止',
  'stop-close-count': '閉じられた回数で配信を停止',
  'stop-click-count': 'クリック回数で配信を停止',
  'day-period': '期間',
  'day-of-week': '曜日',
  'day-time': '時間',
  'frequency': '期間頻度',
  'user-view-limit': 'ユーザー毎の発生回数'
}
export const rulememoList = {
  'visit-count': 'セッション有効期限（30分）以上の間隔でサイトにアクセスした回数でルールを指定できる',
  'last-page-view': 'セッション有効期限（30分）以上の指定時間のアクセス間隔でルールを指定できる',
  'page-view-count': 'サイト内ページの表示回数、セッション内か過去のセッションを含むのかも指定できる',
  'stay-seconds': 'サイト内の滞在時間、以前のセッションからの継続時間でも設定できる',
  'view-page-path': '特定のページのパスの閲覧回数、セッション内か過去のセッションを含むのかも指定できる',
  'last-page-path': '直近のセッションの最後のページのパスを指定できる',
  'walk-3pages': '現在のセッションの３階層のページのパスで指定できる',
  'referer': 'サイトに来る前にいたページのホスト名（ドメイン）で指定できる',
  'utm-source': 'メールやLINEなど販促の際にリンクにつけるクエリーキー（タグ）で指定できる',
  'src-link-path': 'サイト内の１つ前に閲覧したページで指定できる',
  'user-os': 'ユーザーがアクセスしてきたOSの名前で指定できる',
  'stop-view-count': '指定回数配信を行ったら配信しないようにできる',
  'stop-close-count': '指定回数配信タブを閉じられたら配信しないようにできる',
  'stop-click-count': '指定回数リンクに飛んだら配信しないようにできる',
  'day-period': '期間（日時）で指定できる',
  'day-of-week': '曜日で指定できる',
  'day-time': '時間で指定できる',
  'frequency': '指定期間に1回のみ頻度を設定できる',
  'user-view-limit': 'ユーザー毎に発生する回数を指定できる'
}
export const ruleFormatList = {
  'visit-count': { type: 'visit-count', count: '', operator: '' },
  'last-page-view': { type: 'last-page-view', threashold: '', operator: '' },
  'page-view-count': { type: 'page-view-count', scope: '', count: '', operator: '' },
  'stay-seconds': { type: 'stay-seconds', scope: '', seconds: '', operator: '' },
  'view-page-path': { type: 'view-page-path', scope: '', page: '', count: '', operator: '' },
  'last-page-path': { type: 'last-page-path', page: '', operator: '' },
  'walk-3pages': { type: 'walk-3pages', page1: '', page2: '', page3: '' },
  'referer': { type: 'referer', page: '', operator: '' },
  'utm-source': { type: 'utm-source', value: '', operator: '' },
  'src-link-path': { type: 'src-link-path', link: '', operator: '' },
  'user-os': { type: 'user-os', value: '', operator: '' },
  'stop-view-count': { type: 'stop-view-count', scope: '', count: '' },
  'stop-close-count': { type: 'stop-close-count', scope: '', count: '' },
  'stop-click-count': { type: 'stop-click-count', scope: '', count: '' },
  'day-period': { type: 'day-period', start: '', end: '', timezone: '' },
  'day-of-week': { type: 'day-of-week', values: ['', '', ''], timezone: '' },
  'day-time': { type: 'day-time', start: '', end: '', timezone: '' },
  'frequency': { type: 'frequency', periodType: '', timezone: '', interval: '', dayOfWeekThreshold: '', dayThreshold: '', hourThreshold: '', minuteThreshold: '' },
  'user-view-limit': { type: 'user-view-limit', scope: '', count: '' }
}
export const jpList = {
  'count': '回数',
  'operator': '演算子',
  'threashold': '秒数',
  'scope': 'セッションの範囲',
  'seconds': '秒数',
  'page': 'ページパス',
  'page1': '２つ前のアクセスページパス',
  'page2': '１つ前のアクセスページパス',
  'page3': 'アクションの起きるアクセスページパス',
  'value': 'クエリーキー',
  'link': 'ページパス',
  'start': '開始',
  'end': '終了',
  'values': '曜日を英語で,区切りで入力してください',
  'timezone': 'タイムゾーン',
  'lt': 'より小さい',
  'le': '以下',
  'eq': '一致する',
  'ge': '以上',
  'gt': 'より大きい',
  'ne': '一致しない',
  'all': '今までのセッション全体から',
  'previous': '過去のセッションから',
  'current': '現セッションから',
  'periodType': '期間タイプ',
  'interval': '期間',
  'dayOfWeekThreshold': '区切りにする曜日',
  'dayThreshold': '区切りにする日',
  'hourThreshold': '区切りにする時間',
  'minuteThreshold': '区切りにする分',
  'hour': '時間で期間を作る',
  'day': '日で期間を作る',
  'week': '週で期間を作る',
  'month': '月で期間を作る',
  '1': '月曜日',
  '2': '火曜日',
  '3': '水曜日',
  '4': '木曜日',
  '5': '金曜日',
  '6': '土曜日',
  '7': '日曜日'
}

export const timezoneList = {
  'Etc/GMT+12': '(UTC-12:00) 国際日付変更線 西側',
  'Etc/GMT+11': '(UTC-11:00) 協定世界時-11',
  'Pacific/Honolulu': '(UTC-10:00) ハワイ',
  'America/Anchorage': '(UTC-09:00) アラスカ',
  'America/Santa_Isabel': '(UTC-08:00) バハカリフォルニア',
  'America/Los_Angeles': '(UTC-08:00) 太平洋標準時(米国およびカナダ)',
  'America/Chihuahua': '(UTC-07:00) チワワ、ラパス、マサトラン',
  'America/Phoenix': '(UTC-07:00) アリゾナ',
  'America/Denver': '(UTC-07:00) 山地標準時(米国およびカナダ)',
  'America/Guatemala': '(UTC-06:00) 中央アメリカ',
  'America/Chicago': '(UTC-06:00) 中部標準時(米国およびカナダ)',
  'America/Regina': '(UTC-06:00) サスカチュワン',
  'America/Mexico_City': '(UTC-06:00) グアダラハラ、メキシコシティ、モンテレー',
  'America/Bogota': '(UTC-05:00) ボゴタ、リマ、キト',
  'America/Indiana/Indianapolis': '(UTC-05:00) インディアナ東部',
  'America/New_York': '(UTC-05:00) 東部標準時(米国およびカナダ)',
  'America/Caracas': '(UTC-04:30) カラカス',
  'America/Halifax': '(UTC-04:00) 大西洋標準時(カナダ)',
  'America/Asuncion': '(UTC-04:00) アスンシオン',
  'America/La_Paz': '(UTC-04:00) ジョージタウン、ラパス、マナウス、サンフアン',
  'America/Cuiaba': '(UTC-04:00) クイアバ',
  'America/Santiago': '(UTC-04:00) サンチアゴ',
  'America/St_Johns': '(UTC-03:30) ニューファンドランド',
  'America/Sao_Paulo': '(UTC-03:00) ブラジリア',
  'America/Godthab': '(UTC-03:00) グリーンランド',
  'America/Cayenne': '(UTC-03:00) カイエンヌ、フォルタレザ',
  'America/Argentina/Buenos_Aires': '(UTC-03:00) ブエノスアイレス',
  'America/Montevideo': '(UTC-03:00) モンテビデオ',
  'Etc/GMT+2': '(UTC-02:00) 協定世界時-2',
  'Atlantic/Cape_Verde': '(UTC-01:00) カーボベルデ諸島',
  'Atlantic/Azores': '(UTC-01:00) アゾレス',
  'Africa/Casablanca': '(UTC+00:00) カサブランカ',
  'Atlantic/Reykjavik': '(UTC+00:00) モンロビア、レイキャビク',
  'Europe/London': '(UTC+00:00) ダブリン、エジンバラ、リスボン、ロンドン',
  'Etc/GMT': '(UTC+00:00) 協定世界時',
  'Europe/Berlin': '(UTC+01:00) アムステルダム、ベルリン、ベルン、ローマ、ストックホルム、ウィーン',
  'Europe/Paris': '(UTC+01:00) ブリュッセル、コペンハーゲン、マドリード、パリ',
  'Africa/Lagos': '(UTC+01:00) 西中央アフリカ',
  'Europe/Budapest': '(UTC+01:00) ベオグラード、ブラチスラバ、ブダペスト、リュブリャナ、プラハ',
  'Europe/Warsaw': '(UTC+01:00) サラエボ、スコピエ、ワルシャワ、ザグレブ',
  'Africa/Windhoek': '(UTC+01:00) ウィントフック',
  'Europe/Istanbul': '(UTC+02:00) アテネ、ブカレスト、イスタンブール',
  'Europe/Kiev': '(UTC+02:00) ヘルシンキ、キエフ、リガ、ソフィア、タリン、ビリニュス',
  'Africa/Cairo': '(UTC+02:00) カイロ',
  'Asia/Damascus': '(UTC+02:00) ダマスカス',
  'Asia/Amman': '(UTC+02:00) アンマン',
  'Africa/Johannesburg': '(UTC+02:00) ハラーレ、プレトリア',
  'Asia/Jerusalem': '(UTC+02:00) エルサレム',
  'Asia/Beirut': '(UTC+02:00) ベイルート',
  'Asia/Baghdad': '(UTC+03:00) バグダッド',
  'Europe/Minsk': '(UTC+03:00) ミンスク',
  'Asia/Riyadh': '(UTC+03:00) クエート、リヤド',
  'Africa/Nairobi': '(UTC+03:00) ナイロビ',
  'Asia/Tehran': '(UTC+03:30) テヘラン',
  'Europe/Moscow': '(UTC+04:00) モスクワ、サンクトペテルブルグ、ボルゴグラード',
  'Asia/Tbilisi': '(UTC+04:00) トビリシ',
  'Asia/Yerevan': '(UTC+04:00) エレバン',
  'Asia/Dubai': '(UTC+04:00) アブダビ、マスカット',
  'Asia/Baku': '(UTC+04:00) バクー',
  'Indian/Mauritius': '(UTC+04:00) ポートルイス',
  'Asia/Kabul': '(UTC+04:30) カブール',
  'Asia/Tashkent': '(UTC+05:00) タシケント',
  'Asia/Karachi': '(UTC+05:00) イスラマバード、カラチ',
  'Asia/Colombo': '(UTC+05:30) スリジャヤワルダナプラコッテ',
  'Asia/Kolkata': '(UTC+05:30) チェンナイ、コルカタ、ムンバイ、ニューデリー',
  'Asia/Kathmandu': '(UTC+05:45) カトマンズ',
  'Asia/Almaty': '(UTC+06:00) アスタナ',
  'Asia/Dhaka': '(UTC+06:00) ダッカ',
  'Asia/Yekaterinburg': '(UTC+06:00) エカテリンブルグ',
  'Asia/Rangoon': '(UTC+06:30) ヤンゴン(ラングーン)',
  'Asia/Bangkok': '(UTC+07:00) バンコク、ハノイ、ジャカルタ',
  'Asia/Novosibirsk': '(UTC+07:00) ノヴォシビルスク',
  'Asia/Krasnoyarsk': '(UTC+08:00) クラスノヤルスク',
  'Asia/Ulaanbaatar': '(UTC+08:00) ウランバートル',
  'Asia/Shanghai': '(UTC+08:00) 北京、重慶、香港特別行政区、ウルムチ',
  'Australia/Perth': '(UTC+08:00) パース',
  'Asia/Singapore': '(UTC+08:00) クアラルンプール、シンガポール',
  'Asia/Taipei': '(UTC+08:00) 台北',
  'Asia/Irkutsk': '(UTC+09:00) イルクーツク',
  'Asia/Seoul': '(UTC+09:00) ソウル',
  'Asia/Tokyo': '(UTC+09:00) 大阪、札幌、東京',
  'Australia/Darwin': '(UTC+09:30) ダーウィン',
  'Australia/Adelaide': '(UTC+09:30) アデレード',
  'Australia/Hobart': '(UTC+10:00) ホバート',
  'Asia/Yakutsk': '(UTC+10:00) ヤクーツク',
  'Australia/Brisbane': '(UTC+10:00) ブリスベン',
  'Pacific/Port_Moresby': '(UTC+10:00) グアム、ポートモレスビー',
  'Australia/Sydney': '(UTC+10:00) キャンベラ、メルボルン、シドニー',
  'Asia/Vladivostok': '(UTC+11:00) ウラジオストク',
  'Pacific/Guadalcanal': '(UTC+11:00) ソロモン諸島、ニューカレドニア',
  'Etc/GMT-12': '(UTC+12:00) 協定世界時+12',
  'Pacific/Fiji': '(UTC+12:00) フィジー、マーシャル諸島',
  'Asia/Magadan': '(UTC+12:00) マガダン',
  'Pacific/Auckland': '(UTC+12:00) オークランド、ウェリントン',
  'Pacific/Tongatapu': '(UTC+13:00) ヌクアロファ',
  'Pacific/Apia': '(UTC+13:00) サモア'
}



// WEBPACK FOOTER //
// ./src/constants/index.js